<template>
  <div>
    <h1>Search Room</h1>
    <div>
      <input v-model="query" type="text" :placeholder="waiting ? `Search Room` : `Search ${roomNumber.toFixed(0)} Rooms: `" />
    </div>

    <div v-if="roomList.length > 0">
      <ul>
        <li :key="room._id" v-for="room in roomList">
          <span>
            {{ room.title }}
          </span>
          <p>
            {{ room.desc }}
          </p>
          <button @click="$router.push(`/room/${room._id}`)">Go 🏛</button>
          <button @click="addFav({ room }); $forceUpdate();">Fav 💖</button>
        </li>
      </ul>
      <!-- <pre>{{ roomList }}</pre> -->
    </div>
    <div v-if="API.Status.state.favRooms.length > 0">
      <h1>
        My Rooms
      </h1>
      <ul>
        <li :key="room._id" v-for="room in API.Status.state.favRooms">
          <span>
            {{ room.title }}
          </span>
          <p>
            {{ room.desc }}
          </p>
          <button @click="$router.push(`/room/${room._id}`)">Go</button>
          <button @click="removeFav({ room }); $forceUpdate();">🗑</button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { API } from '@/yoteach2-gui/parts/index.js'
export default {
  data () {
    return {
      waiting: true,
      roomNumber: 0,
      API,
      query: '',
      roomList: []
    }
  },
  watch: {
    query () {
      this.search({ title: this.query || '_' })
    }
  },
  methods: {
    search: _.debounce(function ({ title }) {
      API.searchRoom({ title })
        .then((resp) => {
          this.roomList = resp.data
        })
    }, 500),
    getFeaturedRooms () {
      API.listFeaturedRooms().then((resp) => {
        this.roomList = resp.data
      })
    },
    addFav ({ room }) {
      API.Status.addFavRoom({ favRoom: room })
    },
    removeFav ({ room }) {
      API.Status.removeFavRoom({ favRoom: room })
    },
    getRoomCount () {
      API.countRooms()
        .then((resp) => {
          this.roomNumber = resp.data
          this.waiting = false
        })
    }
  },
  mounted () {
    this.getRoomCount()
    this.getFeaturedRooms()
  }
}
</script>

<style>

</style>
